var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"min-h-screen h-full w-full absolute left-0 top-0",staticStyle:{"background":"linear-gradient(77deg, #0F8487 14%, #4D456F 124%)","clip-path":"ellipse(100% 240px at 50% 0%)","z-index":"-1"}})])
}]

export { render, staticRenderFns }